module.exports = __webpack_public_path__ + "static/img/magistratura.530a48d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/magistratura.png
// module id = mppL
// module chunks = 9